import { SUPPORT_MAX_ATTACHMENTS, type TicketStatus } from '@capsico/contracts';
import type { ChatMessages, PhotoMessages } from '../hooks/useSupport';
import type { Translate } from './index';

/* Copy for the Help screens (W16), shared by the hub, the new-chat form and the chat. */

export function photoMessages(t: Translate): PhotoMessages {
  return {
    badType: t('help.photoType'),
    tooBig: t('help.photoSize'),
    tooMany: t('help.photoMany', { max: SUPPORT_MAX_ATTACHMENTS }),
    uploadFailed: t('help.photoUpload'),
  };
}

export function chatMessages(t: Translate): ChatMessages {
  return {
    ...photoMessages(t),
    sendFailed: t('help.sendFailed'),
    actionFailed: t('help.actionFailed'),
    agentAsked: t('help.agentAsked'),
    callAsked: t('help.callAsked'),
    rated: t('help.rated'),
  };
}

export const statusLabel = (t: Translate, status: TicketStatus) => t(`help.status.${status}`);
